import React, { useState } from 'react';
import Login from './Login';
import AzureLogin from './AzureLogin';
import NewRegister from './NewRegister';
import SustainabilityForm from './SustainabilityForm';
import ForgotPassword from './ForgotPassword';
import { useAuth } from '../../contexts/AuthContext';

type AuthStep = 'login' | 'register' | 'sustainability' | 'forgotPassword';

interface AuthFlowProps {
  userType: 'externo' | 'interno';
  onBack: () => void;
}

const AuthFlow: React.FC<AuthFlowProps> = ({ userType, onBack }) => {
  const [currentStep, setCurrentStep] = useState<AuthStep>('login');
  const [registrationData, setRegistrationData] = useState<any>(null);
  const { isAuthenticated, login } = useAuth();

  // Si está autenticado, no mostrar nada (el componente padre mostrará la app principal)
  if (isAuthenticated) {
    return null;
  }

  // Flujo de autenticación
  switch (currentStep) {
    case 'login':
      // Si es usuario interno (Administrador), usar login con Azure AD
      if (userType === 'interno') {
        return <AzureLogin onBack={onBack} />;
      }
      
      // Si es usuario externo (Proponente), usar login tradicional
      return (
        <Login
          userType={userType}
          onSwitchToRegister={() => setCurrentStep('register')}
          onForgotPassword={() => setCurrentStep('forgotPassword')}
          onBack={onBack}
        />
      );
    
    case 'register':
      return (
        <NewRegister
          userType={userType}
          onSwitchToLogin={() => setCurrentStep('login')}
          onRegistrationComplete={(userData) => {
            // Guardar datos de registro y mostrar formulario de sostenibilidad
            setRegistrationData(userData);
            setCurrentStep('sustainability');
          }}
          onBack={() => setCurrentStep('login')}
        />
      );
    
    case 'forgotPassword':
      return (
        <ForgotPassword
          onBack={() => setCurrentStep('login')}
        />
      );
    
    case 'sustainability':
      return (
        <SustainabilityForm
          userData={registrationData}
          onComplete={async () => {
            // El login ya se hizo en el formulario de sostenibilidad
            // La aplicación principal se mostrará automáticamente
          }}
          onSkip={async () => {
            // Aunque omita sostenibilidad, hacer login automático
            if (registrationData) {
              try {
                await login(registrationData.username, registrationData.password);
              } catch (error) {
                console.error('Error en login automático:', error);
                // Si falla el login automático, volver al login
                setCurrentStep('login');
              }
            }
          }}
        />
      );
    
    default:
      return (
        <Login
          userType={userType}
          onSwitchToRegister={() => setCurrentStep('register')}
          onForgotPassword={() => setCurrentStep('forgotPassword')}
          onBack={onBack}
        />
      );
  }
};

export default AuthFlow;
